/**
 * WordPress dependencies
 */
export * from '@wordpress/plugins';
